import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-skelton',
  templateUrl: './skelton.component.html',
  styleUrls: ['./skelton.component.css']
})
export class SkeltonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
